import httpService from "./httpService";

export default {
  findByCaseMasterId(caseMasterId) {
    let params = {caseMasterId: caseMasterId};
    return httpService.get("/hcCaseCommands/findByCaseMasterId", {
      params: params
    });
  },

  findAllByHcCaseCommandsCommonId(hcCaseCommandsCommonId) {
    let params = {hcCaseCommandsCommonId: hcCaseCommandsCommonId};
    return httpService.get("/hcCaseCommands/findAllByHcCaseCommandsCommonId", {
      params: params
    });
  },

  findById(id) {
    return httpService.get(`/hcCaseCommands/${id}`);
  },

  baoCaoChiDao(id, form) {
    return httpService.put(`/hcCaseCommands/${id}/baoCaoChiDao`, form);
  },

  pheDuyet(id) {
    return httpService.put(`/hcCaseCommands/${id}/pheDuyet`);
  },

  yeuCauBoSung(id, form) {
    return httpService.put(`/hcCaseCommands/${id}/yeuCauBoSung`, form);
  },

  giaHan(id, form) {
    return httpService.put(`/hcCaseCommands/${id}/giaHan`, form);
  },

  dangKyDeadline(id, form) {
    return httpService.put(`/hcCaseCommands/${id}/dangKyDeadline`, form);
  },

  huyYeuCau(id, form) {
    return httpService.put(`/hcCaseCommands/${id}/huyYeuCau`, form);
  },

  choYKien(id, form) {
    return httpService.put(`/hcCaseCommands/${id}/choYKien`, form);
  },
};



// WEBPACK FOOTER //
// ./src/services/hcCaseCommandsService.js